import { useState, useEffect, useCallback } from 'react';
import useAxios from '../axios/useAxios';
import { useSelector } from 'react-redux';

export const useFeedbackDrawer = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [sentryButtonRef, setSentryButtonRef] = useState(null);

  const openDrawer = useCallback(() => {
    setIsDrawerOpen(true);
  }, []);

  const closeDrawer = useCallback(() => {
    setIsDrawerOpen(false);
  }, []);

  // Intercept click on sentry button
  useEffect(() => {
    let sentryButton = null;
    let retryCount = 0;
    const maxRetries = 30;

    const findSentryButton = () => {
      const sentryContainer = document.getElementById('sentry-feedback');

      if (sentryContainer?.shadowRoot) {
        const sentryWidget = sentryContainer.shadowRoot.querySelector('.widget__actor');
        if (sentryWidget) {
          // Add svg style
          const sentryWidgetSvg = sentryWidget.querySelector('svg');
          if (sentryWidgetSvg) {
            sentryWidgetSvg.style.fill = 'white'
            sentryWidgetSvg.style.transform = 'rotateY(180deg)'
          }

          // Attach sentry button
          sentryButton = sentryWidget;
          setSentryButtonRef(sentryWidget);

          const handleSentryClick = (event) => {
            event.preventDefault();
            event.stopPropagation();
            openDrawer();
          };

          sentryButton.addEventListener('click', handleSentryClick, { capture: true });

          // Cleanup function
          return () => {
            if (sentryButton) {
              sentryButton.removeEventListener('click', handleSentryClick, { capture: true });
            }
          };
        }
      }

      // Retry if button is not found
      if (!sentryButton && retryCount < maxRetries) {
        retryCount++;
        setTimeout(findSentryButton, 200);
      }

      return null;
    };

    const cleanup = findSentryButton();

    return cleanup;
  }, [openDrawer]);

  return {
    isDrawerOpen,
    openDrawer,
    closeDrawer,
    sentryButtonRef
  };
};


export const useFeedbackLogger = () => {
  const axiosInstance = useAxios();

  const logUserFeedback = useCallback((orderId, feedbackData, feedbackType) => {
    try {
      axiosInstance.post(`/user/feedback/general`, {
        orderId,
        feedbackData,
        feedbackType
      });

    } catch (error) {
      console.error(error);
    }
  }, [axiosInstance]);

    const logUserFeedbackOnCrashReport = useCallback((orderId, feedbackData, crashData) => {
      try {
        axiosInstance.post(`/user/feedback/crash`, {
          orderId,
          feedbackData,
          crashData
        });
  
      } catch (error) {
        console.error(error);
      }
    }, [axiosInstance]);

  return {
    logUserFeedback,
    logUserFeedbackOnCrashReport
  };
}